import { Component, HostListener } from '@angular/core';
import { FeaturesFlagService } from '@shared/services/features-flag.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private featuresFlagsService: FeaturesFlagService) {
    this.featuresFlagsService.getAllFeaturesFlags();
  }
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth >= 905) {
      if (document.querySelector('.sidebar')) {
        document.querySelector('.sidebar').classList.remove('open');
      }
    }
  }
}
